import { Box, Flex, Heading, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import 'source/borrower/borrower.scss';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import CapitalProviderContextProvider from 'packages/organization/hooks/CapitalProviderContextProvider';
import { OutstandingLedgerViewContainer } from 'packages/statements/ui/OutstandingLedgerViewContainer';
import { StatementsTemplate } from 'packages/statements/ui/StatementsTemplate';

export const StatementsOutstandingLedgerRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load outstanding balance route`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <Flex justify="space-between">
          <Heading as="h2">Statements</Heading>
          <Box>
            <CreditFacilitySelect />
          </Box>
        </Flex>
        <StatementsTemplate>
          <CapitalProviderContextProvider renderLoading={<Skeleton />}>
            <OutstandingLedgerViewContainer
              creditFacilityId={creditFacilityId}
            />
          </CapitalProviderContextProvider>
        </StatementsTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
